import api from "./axiosAPI";

export const customersAPI = {
    getCustomerMargins: (startDate, endDate, page = 1, pageSize = 10, ordering = 'revenue', searchTerm = '') => {
        // build parameters
        const params = new URLSearchParams({
            search: searchTerm,
            date_start: startDate,
            date_end: endDate,
            page,
            page_size: pageSize,
            ordering,
        });

        return api.get(`customers/margins/?${params.toString()}`);
    },

    getAllCompaniesMarginsPerDate: (startDate, endDate, searchTerm = '', ordering = 'revenue', granularity = 'day') => {
        const params = new URLSearchParams({
            search: searchTerm,
            date_start: startDate,
            date_end: endDate,
            ordering,
            granularity,
        });
        return api.get(`customers/revenue-profit-per-date/?${params.toString()}`);
    },

    getCustomer(customerId, startDate, endDate) {
        const params = new URLSearchParams({
            date_start: startDate,
            date_end: endDate,
        });
        return api.get(`customers/${customerId}/customer-detail-view/?${params.toString()}`);
    }
};